/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'locales/fi': {
    width: 1800,
    height: 1100,
    viewBox: '0 0 1800 1100',
    data: '<path pid="0" _fill="#fff" d="M0 0h1800v1100H0z"/><path pid="1" _fill="#003580" d="M0 400h1800v300H0z"/><path pid="2" _fill="#003580" d="M500 0h300v1100H500z"/>'
  }
})
